<template>
    <div class="calculating-progress">
            <div class="progres-info">
            <div class="loading_spinner-wrapper">
                <transition name="fade" mode="out-in">
                    <div class="sk-fading-circle">
                        <div class="sk-circle1 sk-circle"></div>
                        <div class="sk-circle2 sk-circle"></div>
                        <div class="sk-circle3 sk-circle"></div>
                        <div class="sk-circle4 sk-circle"></div>
                        <div class="sk-circle5 sk-circle"></div>
                        <div class="sk-circle6 sk-circle"></div>
                        <div class="sk-circle7 sk-circle"></div>
                        <div class="sk-circle8 sk-circle"></div>
                        <div class="sk-circle9 sk-circle"></div>
                        <div class="sk-circle10 sk-circle"></div>
                        <div class="sk-circle11 sk-circle"></div>
                        <div class="sk-circle12 sk-circle"></div>
                    </div>
                </transition>
            </div>
          {{getCalculationInfo()}}</div>
        </div>
</template>

<script>
    export default {
        name: "CalculatingProgress",
        methods: {
            getCalculationInfo(){
                return this.translate("calculation") + " " + this.calculatingPercentage + "%"
            },
            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
        },
        computed: {
            calculatingPercentage() {
                return this.$store.state.calculatingPercentage;
            }
        },
    }
</script>